// src/plugins/clerk.js
import {clerkPlugin} from "@clerk/vue";

// a build constant (vue.config.js, from VIZBI_CLERK), not an environment variable
const clerkPublishableKey = process.env.VITE_CLERK_PUBLISHABLE_KEY || "";

export function createClerkPlugin() {
  const masked =
    typeof clerkPublishableKey === "string" && clerkPublishableKey.length
      ? `length=${clerkPublishableKey.length}`
      : "(empty)";
  console.log(`[Clerk] publishable key baked into bundle: ${masked}`);
  return {
    install(app) {
      const isClient = typeof window !== "undefined";
      if (!isClient) {
        console.log("[Clerk] not in browser, skipping plugin install");
        return;
      }
      if (!clerkPublishableKey) {
        console.log("[Clerk] no publishable key, skipping plugin install");
        window.__clerkEnabled = false;
        return;
      }
      const isOnline = navigator.onLine; // use within plugin, not vueUse/useOnline()
      if (!isOnline) {
        console.log(
          "[Clerk] offline at startup, skipping plugin to avoid " + "failed_to_load_clerk_js"
        );
        window.__clerkEnabled = false;
        return;
      }
      try {
        console.log("[Clerk] installing clerkPlugin");
        app.use(clerkPlugin, {publishableKey: clerkPublishableKey});
        window.__clerkEnabled = true;
        console.log("[Clerk] clerkPlugin installed successfully");
      } catch (error) {
        console.log(`[Clerk] failed to install clerkPlugin: ${error}`);
        window.__clerkEnabled = false;
      }
    }
  };
}
